import Swiper from 'swiper/bundle';
document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.swiper-partner', {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        autoplay: {
            duration: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
        },
    });
});
